<template>
  <div>
    <div class="row">
      <div class="col-6">
        <label for="">Nom</label>
        <input type="text" v-model="vehicle.fullName" class="form-control" />
      </div>

      <div class="col-3">
        <label for="">Catégorie</label>
        <input type="text" class="form-control" />
      </div>
    </div>

    <div class="row justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button class="btn btn-success" @click="save(vehicle)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vehicle: {},
    };
  },
  computed: {},
  methods: {
    async save(data) {
      await this.$store.dispatch("vehicle/store", data);
    },
    async empty() {
      this.$store.commit("vehicle/setVehicle", {});
    },
  },
  beforeMount() {
    this.$store.commit("vehicle/setVehicle", {});
  },
};
</script>
